<template>
  <div class="HidingMessage">
    <div
      class="HidingMessage--toggler button is-rounded has-text-info"
      style="border: none; background: none"
      @click="open = true"
      v-show="!open"
    >
      <i class="fa fa-question-circle" style="font-size: 1.35em;"></i>
    </div>
    <div class="HidingMessage--body message is-info is-small" v-show="open">
      <div class="message-header">
        <slot name="title"></slot>
        <span style="margin-left: auto;" @click="open = false"
          ><i
            class="fa fa-times-circle"
            style="font-size: 1.35em; cursor: pointer;"
          ></i
        ></span>
      </div>
      <div class="message-body"><slot></slot></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HelpMessage",
  data() {
    return {
      open: false
    };
  }
};
</script>

<style lang="scss">
.HidingMessage {
  position: relative;
  &--toggler {
    position: absolute;
    right: -3em;
    top: 0.5em;
  }
  p {
    strong {
      font-weight: 700;
    }
    em {
      font-style: italic;
    }
  }
  h3 {
    font-weight: 700;
  }
}
</style>
